// Translation from legacy filter sort fields to new supported JSONLogic
const sortFieldsToNew = {
  latest_milestone_time: 'trip.latest_actual_milestone.actual_time',
  ocean_delay: 'trip.destination_unload_milestone.delay',
  pred_discharge: 'trip.destination_unload_milestone.predicted_time',
  pred_load: 'trip.origin_load_milestone.predicted_time',
} as const

export default sortFieldsToNew
